import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Paper, Typography, Button } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { emojify } from 'react-emojione';

import { muiThemeLuma } from 'themes';

const useStyles = ({
  palette: {
    common: { white },
    text,
  },
  spacing: { unit },
}) =>
  createStyles({
    card: {
      backgroundColor: 'transparent',
      width: '100%',
      padding: 15,
      flex: 1,
      flexDirection: 'column',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: '0%',
      boxShadow: 'none',
      fontWeight: 500,
      fontSize: 16,
      color: text.secondary,
      textAlign: 'center',
    },
    title: {
      fontWeight: 600,
      fontSize: 22,
      color: muiThemeLuma.palette.text.primary,
      marginBottom: 3 * unit,
      marginTop: 2 * unit,
      textAlign: 'center',
      width: '100%',
    },
    subtitle: {
      color: muiThemeLuma.custom.palette.colorSupportSteel,
      fontSize: 15,
      fontWeight: 500,
      marginBottom: 2 * unit,
      textAlign: 'center',
      width: '100%',
    },
    button: {
      borderRadius: unit / 4,
      padding: `${(unit * 3) / 4}px ${2 * unit}px ${(unit * 3) / 4}px ${(unit * 6) / 4}px`,
      backgroundColor: white,
      '&:hover': {
        backgroundColor: white,
      },
    },
    icon: {
      marginRight: unit,
    },
    label: {
      textTransform: 'uppercase',
    },
  });

class EmptyState extends React.Component {
  renderButtonIcon() {
    const { buttonIcon, buttonIconStyle, classes } = this.props;

    if (buttonIcon && buttonIcon !== '') {
      return (
        <Icon className={classes.icon} style={buttonIconStyle}>
          {buttonIcon}
        </Icon>
      );
    }

    return false;
  }

  render() {
    const {
      buttonLabelStyle,
      buttonStyle,
      buttonText,
      children,
      icon,
      onClickButton,
      style,
      subtitle,
      title,
      classes,
    } = this.props;
    const hasButton = buttonText && buttonText.length > 0;

    return (
      <Paper className={classes.card} style={style}>
        <span style={{ fontSize: 48 }}>{emojify(`${icon}`, { output: 'unicode' })}</span>
        <Typography color="primary" className={classes.title} component="div">
          {title}
        </Typography>
        <Typography color="primary" className={classes.subtitle} component="div">
          {subtitle}
        </Typography>
        {children}
        {hasButton && (
          <Button
            data-lh-id="empty-state-button"
            className={classes.button}
            variant="contained"
            onClick={onClickButton}
            style={buttonStyle}
          >
            {this.renderButtonIcon()}
            <span className={classes.label} style={buttonLabelStyle}>
              {buttonText}
            </span>
          </Button>
        )}
      </Paper>
    );
  }
}

EmptyState.propTypes = {
  buttonIcon: PropTypes.string,
  buttonIconStyle: PropTypes.object,
  buttonLabelStyle: PropTypes.object,
  buttonStyle: PropTypes.object,
  buttonText: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.string,
  onClickButton: PropTypes.func,
  style: PropTypes.object,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

EmptyState.defaultProps = {
  buttonIconStyle: {},
  buttonLabelStyle: {},
  buttonStyle: {},
};

export default withStyles(useStyles)(EmptyState);
